import * as React from 'react';
import styles from '../styles/wizards/EditSubstageWizard.scss';
import EditIcon from '../assets/images/edit-16x16.svg';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { updateSubstage } from '../redux/actions/table/substages';
import { readStage } from '../redux/actions/table/stages';
import EditSubstageForm from '../forms/edit_substage_wizard/EditSubstageForm';

const EditSubstageWizard = ({ onClose, table, stage_id }) => {
  const { edit_substage_wizard: substage } = table;

  const _handleSubmit = (formData) => {
    return validateForm(
      updateSubstage(substage.id, formData).then(() => {
        readStage(stage_id);

        onClose();

        setNotification(__('wizard.edit-substage.notification.success'));
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.edit-substage.title.edit')}</span>
          <span>{__('wizard.edit-substage.subtitle.edit')}</span>
        </div>
        <div className={styles.right}>
          <EditIcon />
        </div>
      </div>
      <div className={styles.body}>
        <EditSubstageForm
          onSubmit={_handleSubmit}
          initialValues={{
            stage_id: substage.stage_id,
            name: substage.name,
            description: substage.description,
            status: substage.status.toString(),
            duration: substage.duration,
            date: {
              start: substage.start_date,
              end: substage.end_date,
            },
          }}
        />
      </div>
    </>
  );
};

export default withRouter(
  mapStateToProps((state) => ({
    table: state.table['substages'],
    stage_id: _.first(state.table['stages'].data).id,
  }))(EditSubstageWizard)
);
